import styled from './main.module.css';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import api from '../../services/api';
import { Alerta } from '../../utils/functions';
import { useContext, useEffect, useState } from 'react';
import ListaUltimosPedidos from '../../components/ListaUltimosPedidos';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../services/global';
import bannertopo from '../../assets/catalogotopo.jpg';
import bannertopo1 from '../../assets/topo1.jpg';
import bannertopo2 from '../../assets/topo2.jpg';
import bannertopo3 from '../../assets/topo3.jpg';
import bannertopo4 from '../../assets/topo4.jpg';
import sitetopo from '../../assets/site_header.jpg';
import taxatopo from '../../assets/taxa_header.jpg';
import parcelartopo from '../../assets/percelar_header.jpg'


const images = [
  bannertopo,
  bannertopo1,
  bannertopo2,
  bannertopo3,
  bannertopo4,
  sitetopo,
  taxatopo,
  parcelartopo,
];



function Main() {
  const login = JSON.parse(localStorage.getItem("login"));
  const cgccli = login.cgccli;

  const [analise, setAnalise] = useState(0);
  const [produzindo, setProduzindo] = useState(0);
  const [entregue, setEntregue] = useState(0);
  const [transporte, setTransporte] = useState(0);
  const [boletos, setBoletos] = useState(0);
  const [vencido, setVencido] = useState(0);
  const [isLoading, setLoading] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);

  const { setTipo, setFiltro, tipo } = useContext(AuthContext);


  const Navigate = useNavigate();


  function handleFiltro(wtipo) {
    setFiltro(wtipo);
    setTipo('4');
  }


  async function Totais() {
    setLoading(true);
    await api.get(`pedidos/totais/?cgccli=${cgccli}`)
      .then((response) => {
        if (!response.data.msg) {
          setLoading(false);
          response.data.map((item) => {
            if (item.status == 'EM ANALISE') {
              setAnalise(item.total);
            }
            if (item.status == 'ENTREGUE') {
              setEntregue(item.total);
            }
            if (item.status == 'PRODUZINDO') {
              setProduzindo(item.total);
            }
            if (item.status == 'EM TRANSPORTE') {
              setTransporte(item.total);
            }
            if (item.status == 'VENCER') {
              setBoletos(item.total);
            }
            if (item.status == 'VENCIDO') {
              setVencido(item.total);
            }
          });

        } else {
          Alerta('Erro!', response.data.msg, 'error')
        }
      }).catch((erro) => {
        //Alerta('Erro!', erro, 'error')
      })
  }

  async function VisitaPage() {
    await api.post(`visita/?cgccli=${cgccli}&page=Catalogo`)
      .then((response) => {


      }).catch((erro) => {

      })
  }


  function OpenBanner() {
    if (currentIndex === 0){
    VisitaPage();
    window.open('https://catalogo.cozimax.com.br' ,"_blank","noopener noreferrer");}
     if (currentIndex === 2){
       window.open(`https://wa.me/5517991236900`,'_blank') 
    }
     if (currentIndex === 1){
       Navigate('/dados'); 
    }
    if (currentIndex === 5){
       window.open(`https://cozimax.com.br`,'_blank')  
    }
  }

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };



  useEffect(() => {
    Totais();

  }, []);

  useEffect(() => {
    if (tipo == '4') {
      Navigate('/Pedidos');
    }

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 7000);

    return () => clearInterval(interval); // limpa ao desmontar
  }, [tipo])



  return (
    <div className={styled.page}>
      <Menu menu="main" />
      <div className={styled.container}>
        <div className={styled.topo}>

          <img src={images[currentIndex]}
            alt="Carrossel"
            style={{
              width: "100%",
              height: "100%",
              //objectFit: "cover",
              borderRadius: "3px",
              transition: "opacity 0.5s ease"

              
            }} onClick={()=> OpenBanner()}></img>

          {/* Indicadores */}
          <div
            style={{
              position: "absolute",
              bottom: "5px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "8px"
            }}
          >
            {images.map((_, index) => (
              <span
                key={index}
                onClick={() => goToSlide(index)}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: currentIndex === index ? "#fff" : "rgba(255,255,255,0.5)",
                  cursor: "pointer"
                }}
              ></span>
            ))}
          </div>




        </div>
        <Header page="Página inicial" />
        <div className={styled.content}>
          <div className={styled.frameultimospedidos}>
            <div className={styled.cardultimospedidos}>
              <div className={styled.cardheader}>
                <div className={styled.cardtitle}>
                  <a>Últimos pedidos</a>
                  <div className={styled.cardtitleline}></div>
                </div>
              </div>
              <div className={styled.cardcontent}>
                <ListaUltimosPedidos qtdreg="8" />
              </div>
            </div>
          </div>
          <div className={styled.framelateral}>
            <div className={styled.card1}>
              <div className={styled.card1content}>
                <div className={styled.card1slot}>
                  <div className={styled.card1rectangule}></div>
                </div>
              </div>
            </div>
            <div className={styled.card2}>
              <div className={styled.card2header}>
                <div className={styled.card2title}>
                  <a>Pedidos</a>
                  <div className={styled.card2titleline}></div>
                </div>
              </div>
              <div className={styled.card2content}>
                <div className={styled.appcard2}>
                  <div onClick={() => handleFiltro('EM ANALISE')} className={styled.card2itens}>
                    {isLoading == true ? <a>Carregando...</a> : <a>Em análise</a>}
                    <span>{analise}</span>
                  </div>
                  <div onClick={() => handleFiltro('PRODUZINDO')} className={styled.card2itens}>
                    {isLoading == true ? <a>Carregando...</a> : <a>Produzindo</a>}
                    <span>{produzindo}</span>
                  </div>
                  <div onClick={() => handleFiltro('EM TRANSPORTE')} className={styled.card2itens}>
                    {isLoading == true ? <a>Carregando...</a> : <a>Em transporte</a>}
                    <span>{transporte}</span>
                  </div>
                  <div onClick={() => handleFiltro('ENTREGUE')} className={styled.card2itens}>
                    {isLoading == true ? <a>Carregando...</a> : <a>Entregue</a>}
                    <span>{entregue}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styled.card3}>
              <div className={styled.card3content}>
                <div className={styled.appboleto}>
                  <div className={styled.appboletoheader}>
                    <div className={styled.appboletoheaderdesc}>
                      <a>Boletos</a>
                      {isLoading == true ? <span>Carregando...</span> :
                        <>
                          <span>{boletos} boletos à vencer</span>
                          <span>{vencido} boletos vencidos</span>
                        </>
                      }

                    </div>
                    <div className={styled.imgboleto}></div>
                  </div>
                  <Link to="/Financeiro" className={styled.btnboleto}>CONSULTAR BOLETOS</Link>
                </div>
              </div>
            </div>
            <div className={styled.card4}>
              <div className={styled.card4content}>
                <div className={styled.card4app}>
                  <div className={styled.card4img}></div>
                  <div className={styled.card4appdesc}>
                    <a>Pesquisa Cozimax</a>
                    <span>Estamos aqui pra te ouvir. Compartilhe como está sendo a sua experiência Cozimax</span>
                  </div>
                </div>
              </div>
              <Link to="/Avaliacao" className={styled.card4btn}>RESPONDER AGORA</Link>
            </div>
          </div>
        </div>

      </div>
    </div >
  )
}


export default Main;